import { render, staticRenderFns } from "./pResult.vue?vue&type=template&id=5cb2c9e4&scoped=true&"
import script from "./pResult.vue?vue&type=script&lang=js&"
export * from "./pResult.vue?vue&type=script&lang=js&"
import style0 from "./pResult.vue?vue&type=style&index=0&id=5cb2c9e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2c9e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
